import { BlocksIconCancelUndo } from 'blocks-nextjs/blocks-web-components/components/icon/icons/cancel-undo';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconCancelUndo = createComponent({ react: React, tagName: 'cat-icon-cancel-undo', elementClass: BlocksIconCancelUndo });
